import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CLEAR_SGI_SESSION, SET_SGI_SESSION, SET_SGI_STATE, SGI_READY } from './actionTypes';
/**
 * Default state for the SGI feature.
 */
const DEFAULT_STATE = {
    session: null,
    sharedState: null,
    iframeReady: false
};
/**
 * SGI Reducer.
 *
 * Manages state for SGI (Sistema de Gerenciamento de Imagens) integration.
 * Handles session lifecycle, shared state synchronization, and iframe readiness.
 */
ReducerRegistry.register('features/sgi', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_SGI_SESSION: {
            const session = {
                sessionId: action.sessionId,
                moderatorId: action.moderatorId,
                moderatorName: action.moderatorName,
                startedAt: action.startedAt || Date.now(),
                active: true
            };
            // A different session must not inherit the previous one's shared state: its version
            // counter restarts from zero, so the stale state would outrank every new update.
            const isSameSession = state.session?.sessionId === action.sessionId;
            return {
                ...state,
                session,
                sharedState: isSameSession ? state.sharedState : null
            };
        }
        case CLEAR_SGI_SESSION:
            return {
                ...DEFAULT_STATE
            };
        case SET_SGI_STATE: {
            const sharedState = {
                ...state.sharedState,
                ...action.sharedState,
                version: action.sharedState?.version ?? (state.sharedState?.version ?? 0) + 1
            };
            return {
                ...state,
                sharedState
            };
        }
        case SGI_READY:
            return {
                ...state,
                iframeReady: action.ready ?? true
            };
        default:
            return state;
    }
});
